import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    CUSTOMERS_QUERY,
    SINGLE_CUSTOMER_QUERY,
    CREATE_CUSTOMER_MUTATION,
    UPDATE_CUSTOMER_MUTATION,
    DELETE_CUSTOMER_MUTATION
} from "@/graphql/customers.js";

const state = {
    customers: []
};
const getters = {};
const mutations = {
    [types.SET_CUSTOMERS](state, customers) {
        state.customers = customers;
    },
    [types.SORT_CUSTOMERS](state) {
        state.customers.sort(function(a, b) {
            return a.node.name.toLowerCase() == b.node.name.toLowerCase()
                ? 0
                : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                ? 1
                : -1;
        });
    },
    [types.UPSERT_CUSTOMER](state, customer) {
        var index = state.customers.findIndex(function(element) {
            return element.node.id == customer.id;
        });

        const node = { node: customer };

        if (index > -1) {
            state.customers.splice(index, 1, node);
        } else {
            state.customers.unshift(node);
        }
    },
    [types.DELETE_CUSTOMER](state, customer) {
        var index = state.customers.find(function(element, index) {
            if (element.id == customer.id) {
                return index;
            }
        });

        if (index > -1) {
            state.customers.splice(index, 1);
        }
    }
};
const actions = {
    async fetchCustomers(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CUSTOMERS_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);

                    const customers = response.data.customers.edges;

                    // update store
                    context.commit(types.SET_CUSTOMERS, customers);

                    // sort
                    context.commit(types.SORT_CUSTOMERS);

                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglCustomer(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_CUSTOMER_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const customer = JSON.parse(
                        JSON.stringify(response.data.customer)
                    );

                    // update store
                    context.commit(types.UPSERT_CUSTOMER, customer);

                    // sort
                    context.commit(types.SORT_CUSTOMERS);

                    resolve(customer);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createCustomer(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_CUSTOMER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const customer = response.data.createCustomer.customer;

                    // update store
                    context.commit(types.UPSERT_CUSTOMER, customer);

                    // sort
                    context.commit(types.SORT_CUSTOMERS);

                    resolve(customer);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateCustomer(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_CUSTOMER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const customer = response.data.updateCustomer.customer;

                    // update store
                    context.commit(types.UPSERT_CUSTOMER, customer);

                    // sort
                    context.commit(types.SORT_CUSTOMERS);

                    resolve(customer);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteCustomer(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_CUSTOMER_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const customer = response.data.deleteCustomer.customer;

                    // update store
                    context.commit(types.DELETE_CUSTOMER, customer);

                    resolve(customer);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
